export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/john-profile-d5502158bba8ccad98c6ba250a2aacc1.png";